import { Switch, Route, Redirect, RouteProps } from 'react-router-dom';
import { useAuthDataContext, AuthData, UserRoles } from './components/AuthDataProvider';
import LoginPage from './pages/Login';
import Auth from './pages/auth';
import { Home } from './pages/Home';
import { AddWaterEvent } from './pages/Water/AddWaterEvent';
import { AddSentreeEvent } from './pages/Sentree/AddSentreeEvent';
import CantFind from './pages/404';
import Unauthorized from './pages/401';
import Cookies from 'js-cookie'
import { jwtDecode } from "jwt-decode";
import LogoutPage from './pages/Logout';
import RefreshPage from './pages/refresh';
import { WaterEvents } from './pages/Water/WaterEvents';
import { WaterEventDetails } from './pages/Water/WaterEventDetails';
import { AllUsers } from './pages/Users/AllUsers';
import { User } from './pages/Users/User';
import { Export } from './pages/Export/Export';
import { SentreeEvents } from './pages/Sentree/SentreeEvents';
import { SentreeEventDetails } from './pages/Sentree/SentreeEventDetails';
import { RheemSensorDetails } from "./pages/Rheem/RheemSensorDetails";
import { RheemDashboard } from "./pages/Rheem/RheemDashboard";
import withAuth from './components/withAuth';


interface privateRouteProps extends RouteProps {
    requiredRoles?: UserRoles[]
}

const PrivateRoute = (routeProps: privateRouteProps) => {
    // We need to decode the cookie here too as this loads faster than context is set... someone w/ JS experience
    // might find a better way to do this
    let { user } = useAuthDataContext();
    if (user === null) {
        const token = Cookies.get('__session') ? Cookies.get('__session') : null;
        if (token) {
            user = jwtDecode<AuthData>(token);
        }
    }
    const userHasRequiredRole = () => {
        if (routeProps.requiredRoles === undefined) {
            return true;
        }
        return routeProps.requiredRoles?.some(r => user?.roles.includes(r));
    }
    const component = withAuth(routeProps.component);
    return (
        user ? (userHasRequiredRole() ? <Route {...routeProps} component={component} /> : <Unauthorized />) : <Redirect to="/login" />
    )
};

const Routes = () => {
    return (
        <Switch>
            <Route exact path="/login" component={LoginPage} />
            <Route exact path="/logout" component={LogoutPage} />
            <Route exact path="/auth" component={Auth} />
            <Route exact path="/refresh" component={RefreshPage} />
            <PrivateRoute exact path="/" component={Home} />
            <PrivateRoute requiredRoles={[UserRoles.allUnauthed]} exact path="/authed" component={Home} />
            <PrivateRoute requiredRoles={[UserRoles.admin]} exact path="/users" component={AllUsers} />
            <PrivateRoute exact path="/user/:userId" component={User} />
            <PrivateRoute exact path="/water/add" component={AddWaterEvent} />
            <PrivateRoute exact path="/sentree/add" component={AddSentreeEvent} />
            <PrivateRoute exact path="/water" component={WaterEvents} />
            <PrivateRoute exact path="/sentree" component={SentreeEvents} />
            <PrivateRoute exact path="/rheem/dashboard" component={RheemDashboard} />
            <PrivateRoute exact path="/rheem/:coreId" component={RheemSensorDetails} />
            <PrivateRoute exact path="/export" component={Export} />
            <PrivateRoute exact path="/water/:waterEventId" component={WaterEventDetails} />
            <PrivateRoute exact path="/sentree/:sentreeEventId" component={SentreeEventDetails} />
            <PrivateRoute>
                <CantFind />
            </PrivateRoute>
        </Switch>
    )
};

export default Routes;
